import React from 'react';
import { Col, Input, UncontrolledTooltip } from 'reactstrap';
import classnames from 'classnames';

const ItemList = ({
  dragRef,
  previewRef,
  handlerId,
  isDragging,
  answer,
  error,
  onChangeAnswer,
  index,
  showConfirmation,
  removeItem,
  className,
  disabled
}) => {
  return (
    <div
      className={classnames(
        'row row--answers',
        { 'row--answers--with-delete sortable-row': !disabled },
        className
      )}
      ref={previewRef}
      data-handler-id={handlerId}
      style={{ opacity: isDragging ? 0 : 1 }}>
      {!disabled && (
        <Col>
          <div
            ref={dragRef}
            className={classnames('sortable-row__pointer', {
              'sortable-row__pointer--dragging': isDragging,
              'text-muted is-other': answer.isOther
            })}>
            <i className="fas fa-sort"></i>
          </div>
        </Col>
      )}
      <Col>
        <Input
          value={answer.answer}
          disabled={disabled}
          invalid={error && !answer.answer}
          onChange={(e) => {
            onChangeAnswer(index, 'answer', e.target.value);
          }}
          placeholder="Answer Text"
        />
      </Col>
      <Col>
        <Input
          value={answer.email}
          disabled={disabled}
          onChange={(e) => {
            onChangeAnswer(index, 'email', e.target.value);
          }}
          placeholder="Alert Email"
        />
      </Col>
      <Col className="d-flex align-items-center">
        <div className="col-form-label">
          <label className="custom-toggle custom-toggle--type-other">
            <input
              type="checkbox"
              checked={answer.isOther || false}
              disabled={disabled}
              onChange={(e) => {
                onChangeAnswer(index, 'isOther', e.target.checked);
              }}
            />
            <span
              className="custom-toggle-slider rounded-circle"
              data-label-off="Select for Other option"
              data-label-on="Select for Other option"
            />
          </label>
        </div>
      </Col>
      {!disabled && (
        <Col>
          <button
            type="button"
            className="table-action table-action-delete"
            id={`tooltip-delete-${answer.id}`}
            onClick={(e) => {
              e.preventDefault();
              showConfirmation({
                title: 'Are you sure want to delete?',
                confirmTitle: 'Delete',
                onConfirm: () => {
                  removeItem(index);
                }
              });
            }}>
            <i className="fas fa-trash" />
          </button>
          <UncontrolledTooltip delay={0} target={`tooltip-delete-${answer.id}`}>
            Delete Answer
          </UncontrolledTooltip>
        </Col>
      )}
    </div>
  );
};

export default ItemList;
